document.addEventListener("DOMContentLoaded", function () {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Fake popup notification — nothing is sent anywhere.
  var toastTimer;
  function showToast(text) {
    var toast = document.querySelector(".js-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "toast js-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    void toast.offsetWidth;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 5000);
  }

  document.querySelectorAll(".js-newsletter-form").forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector("[data-newsletter-msg]");
    if (!input) {
      return;
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var value = input.value.trim();
      var valid = emailPattern.test(value);

      form.classList.remove("is-success", "is-error");

      if (!valid) {
        form.classList.add("is-error");
        input.setAttribute("aria-invalid", "true");
        if (msg) {
          msg.textContent = value ? "Please enter a valid email address." : "Please enter your email address.";
        }
        input.focus();
        return;
      }

      // Demo only: no request is made and no email is sent.
      input.removeAttribute("aria-invalid");
      form.classList.add("is-success");
      if (msg) {
        msg.textContent = "";
      }
      showToast(form.dataset.success || "Thank you! The checklist is on its way to " + value + " (demo, no email was sent).");
      form.reset();
    });
  });
});
